import { type ComponentStyleConfig } from '@chakra-ui/react'

import { pxToRem } from '../../utils/pxToRem'

export const FormError: ComponentStyleConfig = {
  baseStyle: {
    text: {
      fontFamily: 'heading',
      fontSize: pxToRem(14),
      fontWeight: 350,
      color: 'informative.error.100',
    },
  },
  variants: {
    light: {
      text: {
        color: 'informative.error.80',
      },
    },
  },
}
